export default function FreeCardsBg() {
  return (
    <svg
      width="13"
      height="16"
      viewBox="0 0 13 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3228_28898)">
        <rect
          x="3.47372"
          y="-6.50293"
          width="11"
          height="27.1416"
          transform="rotate(30 3.47372 -6.50293)"
          fill="var(--free-cards-svg-2)"
        />
        <rect
          x="-1.62338"
          y="-6.50293"
          width="11"
          height="27.1416"
          transform="rotate(30 -1.62338 -6.50293)"
          fill="var(--free-cards-svg-1)"
        />
      </g>
      <defs>
        <clipPath id="clip0_3228_28898">
          <rect width="13" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
